import React from 'react';
import styles from './UnsavedChangesModal.module.scss';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div style={{display: isOpen ? 'block' : 'none'}}>
      <div className={styles.modalOverlay} onClick={onClose} />
      <div className={styles.optsWrapper}>
        <div className={styles.modalContent}>
          <div className={styles.modalHeader}>
          </div>
          <div className={styles.modalBody}>
            <p>You have unsaved changes to your current route, do you want to continue?</p>
          </div>
          <div className={styles.btnWrapper}>
            <button 
              onClick={onClose}
              style={{
                background: 'none',
                color: '#E64B37',
                fontSize: '20px',
                borderRadius: '10px',
                border: 'none'
              }}
            >
              <span>CANCEL</span>
            </button>
          </div>
        </div>
      </div>

      <div className={styles.doneWrapper}>
        <button 
          onClick={onConfirm}
          style={{
            background: 'none',
            color: '#4F7D9C',
            fontSize: '20px',
            margin: '5px',
            borderRadius: '10px',
            border: 'none'
          }}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default UnsavedChangesModal; 